import { Card, Text } from "@mantine/core";
import { ActionRow, SelectAllRow, SortBar, FieldGrid, ListStatus, RowCheckbox, tintStyle } from "./parts";
import type { MobileView } from "./types";

/** Card list: every row is a card with title + badge, all fields and the buttons. Tapping a card never navigates. */
export function CardList<T>({ view, stagger = true }: { view: MobileView<T>; stagger?: boolean }) {
  if (view.loading || view.rows.length === 0) return <ListStatus view={view} />;
  return (
    <>
    <SortBar view={view} />
    <SelectAllRow view={view} />
    <div className={stagger ? "app-rt-cards app-stagger" : "app-rt-cards"}>
      {view.rows.map((row) => {
        const badge = view.badge?.(row);
        const subtitle = view.subtitle?.(row);
        return (
          <Card
            key={view.rowKey(row)}
            withBorder
            radius="md"
            padding="sm"
            className="app-rt-card"
            style={tintStyle(view.rowBg?.(row), true)}
          >
            <div className="app-rt-card-head">
              <RowCheckbox view={view} row={row} />
              <div className="app-rt-titles">
                <Text fw={600} size="sm" lh={1.3}>{view.title(row)}</Text>
                {subtitle != null && subtitle !== false && (
                  <Text size="xs" c="dimmed" lh={1.3}>{subtitle}</Text>
                )}
              </div>
              {badge != null && badge !== false && <div className="app-rt-badge">{badge}</div>}
            </div>
            <FieldGrid view={view} row={row} />
            <ActionRow view={view} row={row} />
          </Card>
        );
      })}
    </div>
    </>
  );
}
